import React from "react";
import Link from "gatsby-link";
import { Container, Col, Row } from "reactstrap";

import logoNormal from "../../static/img/logo_fischer_marmor_website.png";
import logoDark from "../../static/img/logo_dark_fischer_small.png";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.logo = logoNormal;
  }

  render() {

    if (this.props.theming === 'dark') {
      this.logo = logoDark;
    } else {
      this.logo = logoNormal;
    }

    return (
      <footer>
        <Container>
          <Row className="mt-5 mb-3">
            <Col className="mb-4" md="3" xs="12">
              <img width="150" src={this.logo} alt="Logo Fischer Marmor" />
            </Col>
            <Col md="9" xs="12" className="footer__text">
            <p>Hegestraße 17 - 46244 Bottrop - Tel. 02045 / 25 63 - Fax 02045 / 68 42 </p>
            <p>kontakt@fischermarmor.de - www.fischermarmor.de - <Link className="d-inline-block" to="/impressum/">Impressum</Link> - <a href="https://www.iubenda.com/privacy-policy/21259290/full-legal">Datenschutz</a></p>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js